import { TextElementTemplate, PosterTextData } from '@/types/canvas';

interface MapTextElementsProps {
  textElements: TextElementTemplate[];
  width: number;
  height: number;
  textData?: PosterTextData;
}

export function MapTextElements({ textElements, width, height, textData }: MapTextElementsProps) {
  const labels = ['title', 'subtitle', 'detail'] as const;
  
  return (
    <div className="absolute inset-0 pointer-events-none z-10">
      {textElements.map((textElement, index) => {
        const field = labels[index];
        const content = textData?.[field] || textElement.content;
        
        return (
          <div
            key={textElement.id}
            className="absolute"
            style={{
              left: `${(textElement.x / 100) * width}px`,
              top: `${(textElement.y / 100) * height}px`,
              transform: 'translate(-50%, -50%)',
              fontSize: `${textElement.fontSize}px`,
              fontWeight: textElement.fontWeight,
              fontFamily: textElement.fontFamily,
              color: textElement.color,
              textAlign: textElement.textAlign,
              whiteSpace: 'nowrap',
              zIndex: 10
            }}
          >
            {content}
          </div>
        );
      })}
    </div>
  );
}
